// カードコンポーネントの共通スタイル定数
import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'

// カードのステータスに応じたスタイル
export const CARD_STATUS_STYLES = {
  dismissed: {
    backgroundColor: colorTokens.grey[50],
    opacity: 0.6,
    border: `1px solid ${colorTokens.border.light}`,
  },
  applied: {
    backgroundColor: colorTokens.special.appliedBackground,
    border: `1px solid ${colorTokens.blue[600]}`,
  },
  done: {
    backgroundColor: colorTokens.special.appliedBackground,
    border: `1px solid ${colorTokens.blue[600]}`,
  },
  declined: {
    backgroundColor: colorTokens.grey[50],
    opacity: 0.6,
    border: `1px solid ${colorTokens.border.light}`,
  },
  default: {
    backgroundColor: colorTokens.background.paper,
    border: `1px solid ${colorTokens.border.light}`,
  },
} as const

// カードの共通スタイル
export const CARD_BASE_STYLES = {
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  transition: 'all 0.3s ease',
  hoverShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
  inactiveHoverShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
} as const

// ボタンのスタイル定数
export const ACTION_BUTTON_STYLES = {
  execute: {
    backgroundColor: colorTokens.blue[50],
    borderColor: colorTokens.blue[600],
    color: colorTokens.blue[600],
    hover: {
      backgroundColor: colorTokens.blue[100],
      borderColor: colorTokens.blue[600],
    },
  },
  dismiss: {
    borderColor: colorTokens.border.light,
    color: colorTokens.grey[600],
    hover: {
      borderColor: colorTokens.grey[400],
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
} as const
